import {
  getActiveLocaleSelector,
  getEnvironmentSelector,
  getTenancySelector,
} from '@americanexpress/travel-selectors';
import { useSelector } from 'react-redux';
import { useErrorOnNotOkFetchye } from '@americanexpress/fetchye-amex';
import { getTravelFeatureFlagsOneCmsUrlSelector } from '../selectors/cmsSelector';
import { fetchyeOpts, generateReporting } from '../utils/apiUtils';

export const useCmsFeatureFlag = (flag) => {
  const tenancy = useSelector(getTenancySelector);
  const environment = useSelector(getEnvironmentSelector);
  const locale = useSelector(getActiveLocaleSelector);
  const oneCmsUrl = useSelector(getTravelFeatureFlagsOneCmsUrlSelector);
  const {
    isLoading,
    data,
    error,
  } = useErrorOnNotOkFetchye(
    oneCmsUrl,
    fetchyeOpts,
    generateReporting(
      'src/hooks/useCmsFeatureFlag'
    )
  );

  return {
    isLoading,
    error,
    isEnabled: data?.body[flag]?.[tenancy]?.[environment]?.includes(locale),
  };
};
